import {
	buildPreloadApi,
	buildPreloadedGET,
	buildPreloadListData,
	buildUrlWithParams,
	getListParams,
	getWindowUrl,
} from './utils';
import { PreloadApiManager } from './PreloadApiManager';
import { GET } from '@packages/dataFetch';

const preloadApiManager = new PreloadApiManager({
	apiCallback: GET,
});

/**
 * Preloads API and temporarily stores its promise in preloadApiManager
 * Should be used to enhance the loading speed of API calls made by lazy-loaded javascript
 * @param url Case-sensitive URL
 * @param {object} [options]
 * @param {boolean} [options.includeRouteId] Will include case-sensitive route id from the URL
 * @param {string[]} [options.includeParamsFromUrl] Will include case-insensitive search param keys from the URL
 */
export const preloadApi = buildPreloadApi({
	getWindowUrl,
	buildUrlWithParams,
	preloadApiManager,
});

/**
 * Preloads list page data and temporarily stores its promise in preloadApiManager
 * Should be used to enhance the loading speed of API calls made by lazy-loaded list pages
 * @param url Case-sensitive URL
 */
export const preloadListData = buildPreloadListData({
	getListParams,
	buildUrlWithParams,
	preloadApiManager,
});

/**
 * If exact API was preloaded earlier - retrieves preloaded promise instead of making a new API call
 * If not - works the same way GET does
 */
export const preloadedGET = buildPreloadedGET({
	apiCallback: GET,
	buildUrlWithParams,
	preloadApiManager,
});
